/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-08-12 10:27:50
 *
 *******************************************************/
//@flow

import _ from 'lodash';
import React from 'react';
import { Icon } from '@shopify/polaris';
import { QuestionMarkMajor } from '@shopify/polaris-icons';
import ReactTooltip from 'react-tooltip';

export const RenderLabelTooltip = (props: Object) => {
  const id = _.uniqueId('tooltip');

  return (
    <React.Fragment>
      {props.label ? (
        <div className="Polaris-Labelled__LabelWrapper">
          <div className="Polaris-Label">
            <span style={{ display: 'inline' }} className="default-text-style Polaris-Label__Text">
              <span>{props.label}</span>
              {props.tooltip ? (
                // <span
                //   className={`tooltip ${props.tooltip.length > 100 ? 'long-tooltip' : ''}`}
                //   style={{ marginTop: '4px' }}>
                //   <Tooltip
                //     content={<span className="tooltipContent"> {props.tooltip}</span>}
                //     preferredPosition="above">
                //     <Icon source={QuestionMarkMajor} color="base" />
                //   </Tooltip>
                // </span>

                // Tooltip content
                <span>
                  <span data-tip="dummy data" data-for={id}>
                    <span className="tooltip" style={{ marginTop: '4px' }}>
                      <Icon source={QuestionMarkMajor} color="base" />
                    </span>
                  </span>
                  <ReactTooltip
                    id={id}
                    className="extraTooltipClass Polaris-Tooltip-TooltipOverlay Polaris-Tooltip-TooltipOverlay--positionedAbove"
                    delayHide={props.tooltipDelayHide || 500}
                    effect={props.tooltipEffect || 'solid'}
                    type="light"
                    getContent={function () {
                      return (
                        <div
                          style={props.size && props.size === 'lg' ? { maxWidth: '40rem' } : {}}
                          className="Polaris-Tooltip-TooltipOverlay__Content">
                          {props.tooltip}
                        </div>
                      );
                    }}
                    place={props.tooltipPlace || 'top'}
                  />
                </span>
              ) : (
                ''
              )}
            </span>
          </div>
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};
